module.exports = __webpack_public_path__ + "assets/img/kv-pc.4de7c6a2.jpg";